import ShippingPreferencesSection from "./ShippingPreferencesSection";
export default ShippingPreferencesSection;
